// extracted by mini-css-extract-plugin
export default {"lightbox":"Pg_6l1","content":"hSbmcG","slider":"ZOVmY9","heading":"TVGjmo","title":"mfAVWx","bowlGraphic":"suIyGD","leftBowl":"CKIxUb","rightBowl":"cM18wo","buttons":"Ojn7dM"};